import { reportError } from '@Utils/analytics';

/**
 * Catches the errors a React error boundary cannot see: throws inside event handlers, timers
 * and unawaited promises. On this app that covers most real failures, since almost everything
 * happens in async react-admin mutations.
 *
 * @returns Cleanup function removing the listeners
 */
export const registerGlobalErrorReporting = (): (() => void) => {
  const onError = (event: ErrorEvent) => {
    reportError('Uncaught error', event.error ?? event.message, {
      source: event.filename,
      line: event.lineno,
      column: event.colno,
    });
  };

  const onUnhandledRejection = (event: PromiseRejectionEvent) => {
    reportError('Unhandled promise rejection', event.reason);
  };

  window.addEventListener('error', onError);
  window.addEventListener('unhandledrejection', onUnhandledRejection);

  return () => {
    window.removeEventListener('error', onError);
    window.removeEventListener('unhandledrejection', onUnhandledRejection);
  };
};
